import PropTypes from "prop-types";
import classes from "./styles.module.scss";
import clsx from "classnames";
import { Carousel, Container } from "react-bootstrap";
import ChevronLeft from "@/assets/ChevronLeft.svg";
import ChevronRight from "@/assets/ChevronRight.svg";
import { PromotionalCarouselItem, Title } from "@/ui";

export const PromotionalCarousel = ({ className, items, bgColor, title, titleColor }) => {
  return (
    <div className={clsx(className, classes.promotional, `bg-${bgColor}`)}>
      <Container className="mw-xxl">
        <Title
          className={clsx("mb-4 mt-0", `text-${titleColor}`)}
          title={title}
          tag="h2"
          data-sourceflow-prop="title"
        />
        <Carousel
          className={clsx(className, classes.promotional__carousel)}
          controls={true}
          prevIcon={items.length > 1 && <ChevronLeft width="14" height="25" />}
          nextIcon={items.length > 1 && <ChevronRight width="14" height="25" />}
          indicators={false}
        >
          {items.map(({ title, description, image, video_embed_url, cta }, k) => (
            <Carousel.Item key={k}>
              <PromotionalCarouselItem
                title={title ? title : ""}
                description={description ? description : ""}
                img={image ? image.url : ""}
                video_embed_url={video_embed_url ? video_embed_url : ""}
                cta={cta ? cta : ""}
                dangerousHtml={true}
                fullTitle={true}
              />
            </Carousel.Item>
          ))}
        </Carousel>
      </Container>
    </div>
  );
};

export default PromotionalCarousel;
